<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <app-content-header [contentHeader]="contentHeader"></app-content-header>
        <section>
            <div class="card">
                <div class="card-body p-0">
                    <div *ngFor="let m of monthsNumber; let i = index" class="d-flex px-1 py-2 align-items-center" [ngClass]="i != 11 ? 'border-bottom' : ''">
                        <div class="text-capitalize flex-basis-10">{{monthName(m)}}</div>
                        <div class="flex-basis-50 mx-2" *ngIf="user_report_max_day[m+'']!==null">
                            <input type="number" min="0" max="31" class="form-control" [(ngModel)]="user_report_max_day[m+'']">
                        </div>
                        <div class="flex-basis-50 mx-2" *ngIf="user_report_max_day[m+'']===null">
                            {{"WILL_BE_CALCULATE_DINAMICALLY" | translate}} {{_utilService.themeConfiguration.days_unlock_report}} {{"WILL_BE_CALCULATE_DINAMICALLY_CONTINUE" | translate}}
                        </div>
                        <div class="flex-basis-40">
                            <button class="btn btn-outline-primary" type="button" (click)="user_report_max_day[m+'']=null" *ngIf="user_report_max_day[m+'']!=null"
                                    [ngbTooltip]="'Cliccando qui renderai dinamico il calcolo del giorno di sblocco per questo mese'" placement="left">{{'DYNAMIC' | translate}}</button>
                            <button class="btn btn-outline-primary" type="button" (click)="user_report_max_day[m+'']=1" *ngIf="user_report_max_day[m+'']==null"
                                    [ngbTooltip]="'Cliccando qui renderai statico il calcolo del giorno di sblocco per questo mese'" placement="left">{{'STATIC' | translate}}</button>
                        </div>
                    </div>
                </div>
                <div class="card-footer text-right">
                    <button class="btn btn-primary" (click)="save()">{{'SAVE' | translate}}</button>
                </div>
            </div>
        </section>
    </div>
</div>